import { createSlice } from '@reduxjs/toolkit';
import { gamesFilterSliceProto } from './consts';

export const pvpMyGamesFiltersSlice = createSlice({
  name: 'pvpMyGamesFilters',
  ...gamesFilterSliceProto,
});

export const pvpMyGamesFiltersReducer = pvpMyGamesFiltersSlice.reducer;
